<div class="new-claim-modal container">
  <div class="row">
    <div class="new-claim-modal__content new-claim-modal__content col-12">
      <div class="cx-dialog-header modal-header" style="height: 75px">
        <div class="cx-dialog-title modal-title">
          <span class="label-content"><b>Please confirm stock is ready to be collected? </b></span>
        </div>
        <button
          type="button"
          class="close"
          aria-label="Close"
          cxModal="dismiss"
          cxModalReason="Cross click"
          (click)="closeModal()"
        >
          <i class="fas fa-window-close"></i>
        </button>
      </div>
      <div class="cx-dialog-body modal-body">
        <div class="row">
          <div class="form-group">
            <div class="form-check">
              <input
                formControlName="accept"
                class="form-check-input"
                type="radio"
                value=""
                id="defaultCheck6"
                (change)="changeclaim2($event)"
              />
              <label class="form-check-label" for="defaultCheck6" id="modelLabel2">Yes</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
